import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DefaultPublicDegressivitySlice } from '@classes/default-public-degressivity-slice';
import { DefaultPriceService } from 'app/core/services/default-price.service';
import { IndexService } from 'app/core/services/index.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-price-public-degressivity-slice',
  templateUrl: './price-public-degressivity-slice.component.html',
  styleUrls: ['./price-public-degressivity-slice.component.scss']
})
export class PricePublicDegressivitySliceComponent implements OnInit {

  displayIndexesPrice = false;
  dataSource = new MatTableDataSource<DefaultPublicDegressivitySlice>();
  selectedRowID: string;
  displayedColumns: string[] = [
    // 'number',
    'name',
    'price',
    // 'indexPrice',
    // 'percentage'
  ];
  constructor(
    private uiService: UiService,
    private indexService: IndexService,
    private defaultPriceService: DefaultPriceService
  ) { }

  ngOnInit() {
    this.getDefaultPublicDegressivitySlice();
  }

  selectItemClick(item: DefaultPublicDegressivitySlice) {
    this.selectedRowID = item.id || '';
  }
  getDefaultPublicDegressivitySlice() {
    this.uiService.addRouteLoading();
    this.defaultPriceService.getDefaultPublicDegressivitySlice().subscribe(data => {
      let counter = 1;
      const maxPercentage =Math.max(...data.map(o=>(o.percentage || 0)));
      data.forEach((fe, index) => {
        fe.number = counter;
        fe.indexPrice = (fe.price || 1) * (this.indexService.currentCoef?.value || 1);
        if (!fe.isLastSlice) {
          fe.name = `Jusqu'à ${fe.percentage} % du tonnage minimm annuel`;
        } else {
          fe.name = `Plus de ${maxPercentage} % du tonnage minimm annuel`;
        }
        // if (counter < data.length) {
        //   fe.name = `Jusqu'à ${fe.percentage} % du tonnage minimm annuel`;
        // } else {
        //   fe.name = `Plus de ${data[index-1].percentage} % du tonnage minimm annuel`;  
        // }
        counter++;
      }); 
      this.dataSource.data = data;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }
}
